export default {"src":"/_next/static/media/press-pets-life-today.c0c158b5.svg","height":63,"width":169,"blurWidth":0,"blurHeight":0};